import React from 'react';

import Header2 from '../components/Header2';

const ThankYou = () => {
    return (
        <>
            <Header2 />
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <h1>Thank You!</h1>
                <p>We appreciate your feedback.</p>
            </div>
        </>
    );
};

export default ThankYou;